import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, children }) {
  return (
    <main data-testid="legal-page" className="relative bg-[#050505] text-white min-h-screen">
      <header className="sticky top-0 z-50 backdrop-blur-2xl bg-[#050505]/70 border-b border-white/10">
        <div className="max-w-5xl mx-auto px-6 md:px-10 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-brand" className="flex items-center gap-2 group">
            <span className="inline-block w-2.5 h-2.5 bg-[#FF5A00] rounded-sm group-hover:rotate-45 transition-transform" />
            <span className="font-display text-xl font-semibold tracking-tight">
              Mahaview<span className="text-[#FF5A00]">.in</span>
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm text-zinc-300 hover:text-[#FF5A00] transition-colors"
          >
            <ArrowLeft size={14} /> Back to home
          </Link>
        </div>
      </header>

      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-20 pb-16">
        <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5A00] mb-5">/ Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl md:text-6xl font-semibold tracking-tight leading-[1.05]">
          {title}
        </h1>
        <div className="mt-4 text-xs uppercase tracking-[0.25em] text-zinc-500">
          Last updated · {updated}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-10 pb-32">
        <article className="prose-mv space-y-8 text-zinc-300 leading-relaxed">
          {children}
        </article>
      </section>

      <footer className="border-t border-white/10 py-10 px-6 md:px-10">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-sm text-zinc-400">
          <div className="flex items-center gap-2">
            <span className="inline-block w-2 h-2 bg-[#FF5A00]" />
            <span>© {new Date().getFullYear()} Mahaview.in · All rights reserved.</span>
          </div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-[#FF5A00] transition-colors" data-testid="legal-footer-privacy">Privacy</Link>
            <Link to="/terms" className="hover:text-[#FF5A00] transition-colors" data-testid="legal-footer-terms">Terms</Link>
            <Link to="/" className="hover:text-[#FF5A00] transition-colors" data-testid="legal-footer-home">Home</Link>
          </div>
        </div>
      </footer>

      <style>{`
        .prose-mv h2 {
          font-family: 'Clash Display', 'Plus Jakarta Sans', sans-serif;
          font-size: 1.5rem;
          font-weight: 600;
          letter-spacing: -0.01em;
          color: #fff;
          margin-top: 2rem;
          margin-bottom: 0.75rem;
        }
        .prose-mv p { color: #a1a1aa; }
        .prose-mv ul { list-style: none; padding: 0; margin: 0; }
        .prose-mv ul li {
          position: relative;
          padding-left: 1.25rem;
          color: #a1a1aa;
          margin-bottom: 0.5rem;
        }
        .prose-mv ul li::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0.7rem;
          width: 6px;
          height: 6px;
          background: #FF5A00;
        }
        .prose-mv a { color: #FF5A00; text-decoration: none; border-bottom: 1px solid rgba(255,90,0,0.4); }
        .prose-mv a:hover { border-color: #FF5A00; }
      `}</style>
    </main>
  );
}
